import React from "react";
import { GdanskSaleForm } from "../../../models/GdanskSaleForm";
import GdanskSaleContentContainer from "../GdanskSaleContentContainer";
import useGdanskSummary from "../hooks/useGdanskSummary";
import SaleSummary from "../Other/SaleSummary";
import { GdanskExerciseWeekendRule } from "../Other/GdanskExerciseWeekendRule";
import { GDANSK_KIND_SWIMMING_TRACK } from "./gdanskSaleStepsConsts";
import InstructorSummary from "../Other/InstructorSummary";

interface IProps {
  form: GdanskSaleForm;
  setForm: (form: GdanskSaleForm) => void;
  onGoBack: () => void;
}

const GdanskSaleStep3: React.FC<IProps> = ({ form, setForm, onGoBack }) => {
  const {
    getTitleByProductType,
    ticketsInCurrentBasket,
    handleGoBack,
    loading,
    assorts,
    onAssortAdd,
    onAssortDelete,
    getQnt,
    getTicketLimit,
    onSubmit,
    getPreviousStepInfo,
    instructorAssort,
  } = useGdanskSummary(form, setForm, onGoBack);

  return (
    <GdanskSaleContentContainer
      title={getTitleByProductType()}
      description=""
      showButtons
      disabledAccept={
        ticketsInCurrentBasket() <= 0 ||
        loading ||
        (form.kind === GDANSK_KIND_SWIMMING_TRACK && instructorAssort === undefined)
      }
      showGoBackButton
      onClickGoBack={handleGoBack}
      onClickNext={onSubmit}
      acceptText="Dodaj i przejdź do koszyka"
      previousStepInfo={getPreviousStepInfo()}
    >
      {form.kind === GDANSK_KIND_SWIMMING_TRACK ? (
        <InstructorSummary loading={loading} instructorAssort={instructorAssort} />
      ) : (
        <>
          <GdanskExerciseWeekendRule form={form} />
          <SaleSummary
            assorts={assorts}
            onAssortAdd={onAssortAdd}
            onAssortDelete={onAssortDelete}
            getQnt={getQnt}
            getTicketLimit={getTicketLimit}
            loading={loading}
            ticketsInCurrentBasket={ticketsInCurrentBasket}
          />
        </>
      )}
    </GdanskSaleContentContainer>
  );
};

export default GdanskSaleStep3;
